export default class Table {

    constructor(container, url, columns) {
        this.identity = container;
        this.$table = $(`#${container} table`);
        this.originalUrl = url;
        this.buildUrl();

        let sorting = [[1, 'asc']];
        if (this.$table.hasClass('unsorted')) {
            sorting = [];
        } else if (this.$table.hasClass('nochecks')) {
            sorting = [[0, 'asc']];
        }
        if (this.$table.hasClass('sort-desc')) {
            sorting[0][1] = 'desc';
        }

        this.table = this.$table.DataTable({
            autoWidth: false,
            pageLength: 25,
            ajax: this.url,
            order: sorting,
            columnDefs: [{targets: 0, orderable: false}, {targets: (columns.length - 1), orderable: false}],
            columns: columns,
            serverSide: true,
            stateSave: true,
            oLanguage: {
                sSearch: Lang.dtfilter,
                sLengthMenu: Lang.dtentries,
                sInfoFiltered: Lang.dtfiltered,
                sInfo: Lang.dtinfo,
                sEmptyTable: Lang.dtempty,
                sInfoEmpty: Lang.dtinfoempty,
                sZeroRecords: Lang.dtzero,
                oPaginate: {
                    sNext: Lang.dtnext,
                    sPrevious: Lang.dtprevious
                }
            }
        });

        this.setEvents();
    }

    buildUrl() {
        // build table request
        const urlObj = new URL(`https://${window.location.host}${this.originalUrl}`);
        const params = new URLSearchParams(urlObj.searchParams.toString());
        params.append('app', $('[data-app]').data('app'));
        urlObj.search = params.toString();

        const filterForm = $(`#${this.identity} .filter-form`);
        if (filterForm.find('input, select').length > 0) {
            urlObj.search += `&${filterForm.serialize()}`;
        }

        this.url = urlObj.href;
    }

    scrollit() {
        const self = this;
        const $thead = this.$table.find('thead');
        const offset = this.$table.offset().top;
        const headerHeight = $('#header').outerHeight();
        const threshold = offset - headerHeight - $thead.outerHeight();
        if ($(window).scrollTop() >= threshold && $thead.hasClass('fixed-thead')) {
            $('html, body').stop().animate({
                scrollTop: self.$table.offset().top - headerHeight - self.$table.find('thead').outerHeight() - 1
            }, 600);
        }
    }

    reload(cb) {
        this.table.ajax.reload(cb, false);
    }

    setEvents() {
        const self = this;

        this.table.on('order', function () {
            self.scrollit();
        });
        this.table.on('page', function () {
            self.scrollit();
        });

        $.fn.dataTable.ext.errMode = 'none';
        this.table.on('error.dt', function (e, settings, techNote, message) {
            console.log(e, settings, techNote, message);
            if (techNote === 7) {
                self.$table.find('tbody').html(`<tr><td class="dterror">${Lang.dterror}</td></tr>`);
            }
        });

        //Switch labels
        $('#DataTables_Table_0_filter input').attr('placeholder', Lang.dtfilterplace + '...');
        $(`#${self.identity} .next`).html("&rarr;");
        $(`#${self.identity} .previous`).html("&larr;");

        this.$table.on('reload', function () {
            self.reload();
        });

        $(`#${self.identity} .sel-key`).on('select2:select', function () {
            self.showValues();
        });

        $(`#${self.identity} .sel-val`).on('select2:select', function () {
            self.selectValue();
        });

        const filter_form = $(`#${self.identity} .filter-form`);
        filter_form.on('click', '.remove', function () {
            $(this).parents('li').remove();
            self.buildUrl();
            self.table.ajax.url(self.url);
            self.reload();
        });

        filter_form.on('change', '.changer', function () {
            $(this).parents('li').remove();
            self.buildUrl();
            self.table.ajax.url(self.url);
            self.reload();
        });

        $(`#${self.identity} .table-filter select`).select2();
    }

    showValues() {
        const key = $(`#${this.identity} .sel-key`).val();
        if (key !== '') {
            $(`#${this.identity} .selection-value label`).hide();
            $(`#${this.identity} .selection-value label[data-key="${key}"]`).show();
        }
    }

    selectValue() {
        const key = $(`#${this.identity} .sel-key`).val();
        const value = $(`#${this.identity} label[data-key="${key}"] select`).val();
        const label = $(`#${this.identity} label[data-key="${key}"] select option:selected`).data('label');

        const item = `<li><input type="hidden" name="filter[${key}][]" value="${value}"><span>${label}</span><i class="remove jsicon-wrong"></i></li>`;

        $(`#${this.identity} .filter-form ul`).append(item);
        $(`#${this.identity} .selection-value label`).hide();
        $(`#${this.identity} .table-filter select`).val(null).trigger('change');
        this.buildUrl();
        this.table.page(0);
        this.table.ajax.url(this.url);
        this.reload();
    }
}
